export const CMEMS = {
  title: {
    value: 'COPERNICUS (CMEMS)',
  },
  paragraph: {
    value: `The data set from Copernicus (The European earth observation program from EU) include Global ocean data from the Copernicus Marine Environment Monitoring Service (CMEMS). 
    The CMEMS has been designed to respond to issues emerging in the different sectors. Using information from both satellite and in situ observations, it provides state-of-the-art analyses and forecasts daily, which offer an excellent capability to observe, understand and anticipate marine environment events.
    `,
  },
  table: {
    value: {
      header: ['General', 'Model'],
      hiddenHeaders: ['Model'],
      rows: [
        {
          General: 'Title',
          Model: 'Global Ocean Sea Physical Analysis and Forecast Product from Copernicus (CMEMS)',
        },
        {
          General: 'Geographical Coverage',
          Model: 'Global',
        },
        {
          General: 'Category',
          Model: 'Ocean data',
        },
        {
          General: 'Source Name',
          Model: 'Global_Analysis_Forecast_PHY_001_024',
        },
        {
          General: 'Publisher',
          Model: 'Copernicus Marine Environment Monitoring Service (CMEMS)',
        },
        {
          General: 'Product type',
          Model: 'Grid',
        },
        {
          General: 'Cost (ex. VAT)',
          Model: 'Free',
        },
        {
          General: 'Typical Applications',
          Model: 'Hydrodynamic, Offshore and Marine projects',
        },
        {
          General: 'References',
          Model: `CMEMS home: ***https://marine.copernicus.eu/*** Data product description: Global Ocean Physics Analysis and Forecast | Copernicus Marine Service ***https://data.marine.copernicus.eu/product/GLOBAL_ANALYSISFORECAST_PHY_001_024/description*** Data product user manual: CMEMS-GLO-PUM-001-024.pdf (copernicus.eu) ***https://catalogue.marine.copernicus.eu/documents/PUM/CMEMS-GLO-PUM-001-024.pdf***`,
        },
      ],
    },
  },
  table1: {
    value: {
      header: ['Coverage', 'Model'],
      hiddenHeaders: ['Model'],
      rows: [
        {
          Coverage: 'Geographical Range',
          Model: `Longitude: -180°W to 180°E 
                  Latitude: 90°S to 90°N`,
        },
        {
          Coverage: 'Geographical Resolution',
          Model: `1/12 deg. (approx. 0.083 deg.)`,
        },
        {
          Coverage: 'Vertical Reference',
          Model: 'Sea Surface',
        },
        {
          Coverage: 'Vertical Range',
          Model: 'From 0 m down to -5500 m',
        },
        {
          Coverage: 'Vertical Resolution',
          Model: '50 levels',
        },
        {
          Coverage: 'Temporal Reference',
          Model: 'UTC',
        },
        {
          Coverage: 'Temporal Range',
          Model: `Data Link coverage:
                  1/1-2016 -> Present`,
        },
        {
          Coverage: 'Temporal Resolution',
          Model: 'Daily (daily mean values)',
        },
      ],
    },
  },
  table2: {
    value: {
      header: ['Variables', 'Model'],
      hiddenHeaders: ['Model'],
      rows: [
        {
          Variables: 'Name (Unit)',
          Model: `Sea Surface Height [m]
                  Water Temperature [deg C]
                  Salinity [psu]
                  U-velocity component (East dir.) [m/s]
                  V-velocity component (North dir.) [m/s]`,
        },
      ],
    },
  },
  table3: {
    value: {
      header: ['Credits', 'Model'],
      hiddenHeaders: ['Model'],
      rows: [
        {
          Credits: 'Data product originator',
          Model: 'E.U. Copernicus Marine Service Information',
        },
      ],
    },
  },
};
